module.exports = __webpack_public_path__ + "img/PRCA1_B.3d64fe2e.png";